import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

const buttonGroup = cva('inline-flex items-center', {
  variants: {
    gap: {
      sm: 'gap-1',
      md: 'gap-2',
      lg: 'gap-4',
    },
  },
  defaultVariants: {
    gap: 'md',
  },
});

type KoobButtonGroupProps = Omit<
  React.HTMLAttributes<HTMLDivElement>,
  'className'
> &
  VariantProps<typeof buttonGroup>;

const KoobButtonGroup = React.forwardRef<HTMLDivElement, KoobButtonGroupProps>(
  ({ gap, children, ...props }, ref) => (
    <div ref={ref} role="group" className={buttonGroup({ gap })} {...props}>
      {children}
    </div>
  ),
);

KoobButtonGroup.displayName = 'KoobButtonGroup';

export default KoobButtonGroup;
